////////////////////////////////////////20260327//////////////////////////////////////////////////

import React, { useEffect, useRef, useState } from 'react'
import { needsstamp, getDate, clientContract, alertreturn, getContract, Userstamp } from '../../service/project'
import { companyinfo } from '../../service/dataarray'
import Mainstamp from '../../service/components/Mainstamp'
import Swal from 'sweetalert2'

function Out_Contract_signature({ userinfo, contract, fresh, setStampid, notmain, admin, setContract, stampid }) {
    const [signing, setSigning] = useState(false)
    const [ready, setReady] = useState(false)
    const resolvedStampRef = useRef('')

    useEffect(() => {
        let mounted = true

        const loadMainStamp = async () => {
            try {
                if (!userinfo || !userinfo.userId) {
                    if (mounted) setReady(false)
                    return
                }

                const response = await Userstamp(userinfo.userId)

                const list = response && response.data ? response.data : []

                if (!list.length) {
                    resolvedStampRef.current = ''
                    if (mounted) setReady(false)
                    return
                }

                let targetStamp = null

                if (!notmain) {
                    targetStamp = list.find(function (v) {
                        return Number(v.main) === 1
                    })
                } else {
                    targetStamp =
                        list.find(function (v) {
                            return String(v.id) === String(stampid)
                        }) ||
                        list.find(function (v) {
                            return Number(v.main) === 1
                        })
                }

                if (!targetStamp || !targetStamp.id) {
                    resolvedStampRef.current = ''

                    if (mounted) setReady(false)

                    return
                }

                resolvedStampRef.current = targetStamp.id

                if (typeof setStampid === 'function') {
                    setStampid(targetStamp.id)
                }

                if (mounted) setReady(true)
            } catch (error) {
                resolvedStampRef.current = ''

                if (mounted) setReady(false)
            }
        }

        loadMainStamp()

        return function () {
            mounted = false
        }
    }, [userinfo, fresh, notmain, stampid, setStampid])

    function getFinalStampId() {
        if (resolvedStampRef.current) return resolvedStampRef.current
        if (stampid) return stampid
        if (userinfo && userinfo.confidentstamp) return userinfo.confidentstamp
        return ''
    }

    async function clientContracts() {
        if (signing) return

        const finalStampId = getFinalStampId()

        if (!finalStampId) {
            Swal.fire({
                title: '날인을 선택할 수 없습니다',
                text: '기본 날인을 먼저 확인해주세요',
                icon: 'warning',
            })
            return
        }

        const result = await Swal.fire({
            title: '전자서명 하시겠습니까?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: '네',
            cancelButtonText: '아니요',
        })

        if (!result.isConfirmed) {
            alertreturn('xsign')
            return
        }

        try {
            setSigning(true)

            const response = await clientContract(finalStampId, contract.uid)

            const contractRes = await getContract(contract.uid)
            const latestContract = contractRes && contractRes.data && contractRes.data[0]

            if (latestContract) {
                setContract(latestContract)
            } else {
                const today = getDate()

                setContract({
                    ...contract,
                    clientstamp: finalStampId,
                    c2f: contract.c2f || today,
                })
            }

            alertreturn('contractdone')
        } finally {
            setSigning(false)
        }
    }

    const finalStampId = getFinalStampId()

    return (
        <>
            {userinfo ? (
                <div className={admin ? 'mt40 signaturebox' : 'signaturebox'}>
                    <h3>
                        위의 계약을 체결함에 있어 '을'는 계약일반조건, 개발내역서 등의 모든 업무 및 기술조건을 이행할
                        것을 확약하고 기명날인한다.
                    </h3>

                    <div className="flex j a bottombox">
                        <div className="clientbox w50">
                            <p className="p5">
                                (주소)
                                <span className="ml10">
                                    {userinfo.companyaddressf}
                                    {userinfo.companyaddressm}
                                </span>
                            </p>

                            <p className="p5">
                                (회사명)
                                <span className="comPany ml10">
                                    {userinfo.company}({userinfo.uPhone})
                                </span>
                            </p>

                            <p className="p5">
                                (서명일자)
                                <span className="ml10">{contract.c2f ? contract.c2f : getDate()}</span>
                            </p>

                            <div className="p5">
                                (대표자)
                                <span className="ml10">{userinfo.uName}</span>
                                (인)
                                <span className="stampwrap">
                                    {contract.uid !== 'exampledata' && (contract.c2f || contract.clientstamp) ? (
                                        <Mainstamp
                                            stampnum={finalStampId}
                                            notmain={notmain}
                                            fresh={fresh}
                                            userId={userinfo.userId}
                                        />
                                    ) : null}
                                </span>
                            </div>
                        </div>

                        <div className="rightclientbox w50">
                            <p className="p5">
                                (주소)
                                <span className="ml10">{companyinfo.address}</span>
                            </p>

                            <p className="p5">
                                (회사명)
                                <span className="myCompany ml10">
                                    {companyinfo.mycompany}({companyinfo.comnum})
                                </span>
                            </p>

                            <p className="p5">
                                (서명일자)
                                {/* <span className="ml10">{contract.d1}</span> */}
                                {/* <span className="ml10">{getDate()}</span> */}
                                {/* <span className="ml10">{contract.d1 ? contract.d1 : getDate()}</span>{' '} */}
                                <span className="ml10">{contract.c1f ? contract.c1f : getDate()}</span>
                            </p>

                            <div className="p5">
                                (대표자)
                                <span className="ml10">{companyinfo.representative}</span>
                                (인)
                                <span className="stampwrap">
                                    {contract.uid !== 'exampledata' ? (
                                        <div className="stampbox">{needsstamp}</div>
                                    ) : null}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="flex c a w100">
                        <div className="flex center">
                            {/* {!contract.c2f && !contract.clientstamp ? (
                                <button
                                    className="navibtn_hover"
                                    onClick={clientContracts}
                                    disabled={!ready || !finalStampId || signing}
                                >
                                    {signing ? '서명중...' : '전자서명'}
                                </button>
                            ) : null} */}
                            {!admin && !contract.c2f && !contract.clientstamp ? (
                                <button
                                    className="navibtn_hover"
                                    onClick={clientContracts}
                                    disabled={!ready || !finalStampId || signing}
                                >
                                    {signing ? '서명중...' : '전자서명'}
                                </button>
                            ) : null}

                            {/* {!contract.c2f && !contract.clientstamp ? (
                                <div className="f14 mt10">
                                    <p>날인변경을 원하는 경우 마이페이지에 날인관리에서 변경 가능합니다</p>
                                </div>
                            ) : null} */}
                            {!admin && !contract.c2f && !contract.clientstamp ? (
                                <div className="f14 mt10">
                                    <p>날인변경을 원하는 경우 마이페이지에 날인관리에서 변경 가능합니다</p>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            ) : null}
        </>
    )
}

export default Out_Contract_signature
